/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P3_TInputs */

const en_mk_sec_pg_p3_t = /** @type {(inputs: Mk_Sec_Pg_P3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbound actions need a yes`)
};

const id_mk_sec_pg_p3_t = /** @type {(inputs: Mk_Sec_Pg_P3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan keluar butuh izin`)
};

/**
* | output |
* | --- |
* | "Outbound actions need a yes" |
*
* @param {Mk_Sec_Pg_P3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p3_t = /** @type {((inputs?: Mk_Sec_Pg_P3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p3_t(inputs)
	return en_mk_sec_pg_p3_t(inputs)
});